import React, { useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useMedia } from 'react-use';
import { EnvColorBar } from '../organisms/EnvColorBar';
import { Header } from '../molecules/Header';
import { Footer } from '../molecules/Footer';
import { StylesheetLoader } from '../molecules/StylesheetLoader';
import { rootStore, useRootStore } from '../../App';
import { StickyMessage } from '../organisms/StickyMessage';
import { Attention } from '../atoms/Attention';
import { GenericExceptionPage } from './GenericExceptionPage';
import RootStore from '../../store/RootStore';
import { observe } from 'mobx';

const BaseStyledDiv = styled.div`
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? ''
      : 'display: flex;flex-direction: column;min-height: 100vh;'}
`;

const MainStyledDiv = styled.div`
  padding: 0;
  ${(props: { isWide: boolean }) =>
    props.isWide ? '' : 'display: flex;flex-direction: column;flex-grow: 1;'}
`;

const ContentsStyledDiv = styled.div`
  padding-bottom: 0px;
  padding-top: 0px;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? ''
      : 'background: #f7f7f7;color: #333;display: flex;flex-direction: column;flex-grow: 1;text-align: left;'}
`;

interface Props {
  children: any;
}

export const Layout = observer((props: Props) => {
  const root = useRootStore();
  const isWide = useMedia('(min-width: 480px)');
  root.layoutStore.setWide(isWide);

  const { contentDivRef } = root.layoutStore;
  const contents = generateChildren(root, props.children);

  const contentStylesheet = isWide
    ? '/css/inquiry-history-pc-2.0.0.css'
    : '/css/inquiry-history-sp-2.0.0.css';

  if (root.serviceStore.service && !root.partnerStore?.isReadyToRender) {
    root.partnerStore?.getSsiContents(root.serviceStore.service);
  }

  return (
    <BaseStyledDiv isWide={isWide}>
      <EnvColorBar />
      {root.partnerStore?.isReadyToRender ? (
        <Header
          isRakutenCoJpDomain={false}
          onLoad={() => {
            return;
          }}
        >
          {root.partnerStore?.staticLinkTag +
            '\n' +
            root.partnerStore?.headerHtml}
        </Header>
      ) : (
        <></>
      )}
      <MainStyledDiv isWide={isWide} id={isWide ? 'contents' : ''}>
        <StylesheetLoader
          style={
            isWide
              ? {}
              : { flexGrow: 1, display: 'flex', flexDirection: 'column' }
          }
          href={contentStylesheet}
        >
          <ContentsStyledDiv
            isWide={isWide}
            id="inquiryContents"
            ref={contentDivRef}
          >
            <StickyMessage />
            {contents}
          </ContentsStyledDiv>
          {/* <PopUpSuccess /> */}
        </StylesheetLoader>
      </MainStyledDiv>
      {root.layoutStore.isWide && root.partnerStore?.isReadyToRender ? (
        <Footer isRakutenCoJpDomain={false}>
          {root.partnerStore?.footerHtml}
        </Footer>
      ) : (
        <></>
      )}
    </BaseStyledDiv>
  );
});

const generateChildren = (root: RootStore, originalChildren: any) => {
  const { showErrorPage, showOmniErrorPage } = root.inquiryPageStore;
  if (showErrorPage) {
    return <GenericExceptionPage />;
  } else if (showOmniErrorPage) {
    return (
      <div style={{ backgroundColor: '#fff' }}>
        <Attention title="権限がありません">
          エラー ： 401 Unauthorized
          <br />
          <br />
          認証に失敗しました。
        </Attention>
      </div>
    );
  }
  return originalChildren;
};
